import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center justify-center w-full h-screen z-50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin -ml-1 mr-3 h-10 w-10 mb-4 text-yellow-700",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_3 = { class: "text-center text-xl font-semibold" }
const _hoisted_4 = { class: "w-1/3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("general.loading")), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("general.loading_message")), 1)
      ]))
    : _createCommentVNode("", true)
}